module.exports = __webpack_public_path__ + "img/img54.d6898625.svg";